import axios from "../../service";
import alert from "@/_helpers/alert";
import fn from "@/helpers/utility";
import { AuthService, EmployeeService } from "../resources";
export const state = {
  employeeList: [],
  keyAuth: {
    key: "account_child_flag",
    keyAdvance: "advanced_account_child_flag"
  }
};

export const mutations = {
  INIT_EMPLOYEE_LIST(state, newValue) {
    state.employeeList = newValue;
  },
  UPDATE_EMPLOYEE_LIST(state, newValue) {
    let user = state.employeeList.user.find(
      (o) => o.child_id === newValue.child_id
    );
    if (typeof newValue.child_active !== "undefined") {
      user.active_flag = newValue.child_active;
      Object.assign(state.employeeList.user, user);
    } else if (typeof newValue.child_lv !== "undefined") {
      user.access_level = newValue.child_lv;
      user.access_name = childName(newValue.child_lv);
      Object.assign(state.employeeList.user, user);
    } else if (typeof newValue.child_delete !== "undefined") {
      let index = state.employeeList.user.findIndex(
        (o) => o.child_id === newValue.child_id
      );
      state.employeeList.user.splice(index, 1);
      state.employeeList.total = state.employeeList.total - 1;
    }
  }
};

export const getters = {
  isEmployee(state) {
    return {
      employee: state.employeeList.user || [],
      total: state.employeeList.total || 0
    };
  },

  PermissionFlag(state) {
    return fn.PermissionFlag(state.keyAuth.keyAdvance);
  }
};

export const actions = {


  async addEmployee({ commit, dispatch, getters }, data) {
    try {
      let resp = await EmployeeService.apiCreateEmployee(data);
      return { status: true, ...resp };
    } catch (err) {
      console.error(err.message, "err.message");
      alert.error("เกิดขอผิดพลาด");
    }
  },

  async getEmployee({ commit }, data) {
    try {
      let resp = await EmployeeService.apiGetEmployee(data);
      return { status: true, ...resp };
    } catch (err) {
      console.error(err.message, "err.message");
      alert.error("เกิดขอผิดพลาด");
    }
  },

  async setUpdate({ commit }, data) {
    try {
      let resp = await EmployeeService.apiEditsetUpdate(data);
      return { status: true, ...resp };
    } catch (err) {
      console.error(err.message, "err.message");
      alert.error("เชื่อมต่อ server ไม่ได้");
    }
  },

  async deleteEmployee({ commit }, id) {
    try {
      let resp = await EmployeeService.apiDeleteEmployee(id);
      return { status: true, ...resp };
    } catch (err) {
      console.error(err.message, "err.message");
      alert.error("เชื่อมต่อ server ไม่ได้");
    }
  }

};

function childName(level) {
  switch (level) {
    case 2:
      return "Accountant";
    case 3:
      return "Warehouse Worker";
    case 4:
      return "Manager";
  }
}
